// extracted by mini-css-extract-plugin
export default {"stat":"Stats_stat__rUZKQ","limit":"Stats_limit__Lgt20"};